import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import TransactionFileFactory from "../../Entity/Factories/TransactionFileFactory";
import { TransactionFileInterface } from "../../Entity/Entities/TransactionFile/TransactionFileInterface";

export default function* transactionFileUpload(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_REQUEST
    });

    const res = yield call(Http.post, "transaction-file", action.payload);

    const transactionFile: TransactionFileInterface = TransactionFileFactory.create(res.data);

    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_SUCCESS,
      payload: {
        transactionFileId: transactionFile.id
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-transaction-file-uploaded-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, transactionFile);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_BANK_TRANSACTIONS_SET_TITLE,
      payload: {
        title: Translator.trans("error")
      }
    });

    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchTransactionFileUpload() {
  yield takeEvery(Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_START, transactionFileUpload);
}
